import CustomerServiceModal, { CustomerServiceItem } from 'component/CustomerServiceModal'
import { FullWidthPrimaryButton } from 'commonStyledComponents'
import PlaceboChooserModal from 'component/FullPageError/PlaceboChooserModal'
import {
  MaintenancePageModal,
  MaintenancePageWrapper,
  PageContent,
  PageContentLine,
  PageContentLineWrapper,
  PageTitle,
  SecondButton,
} from 'component/FullPageError/Styled'
import { PRELOAD_DATA_LOCAL_STORAGE_KEY } from 'constant/common'
import { getVisitorId } from 'redux/saga/user'
import { getMetadataJSONWithUrlWithCache } from 'utils/id-util/update-util'
import { useCallback, useState } from 'react'

interface StartupConnectionReminderProps {
  isOpen: boolean
  onAction: () => void
}

export default function StartupConnectionReminder({ isOpen, onAction }: StartupConnectionReminderProps) {
  const [contactOpen, setContactOpen] = useState(false)
  const [contactList, setContactList] = useState<CustomerServiceItem[]>([])
  const [placeboChooserOpen, setPlaceboChooserOpen] = useState(false)

  const handleRetry = useCallback(() => {
    window.location.replace('/')
  }, [])

  const handleSwitchLine = useCallback(() => {
    onAction()
    setPlaceboChooserOpen(true)
  }, [onAction])

  const handleContact = useCallback(async () => {
    onAction()
    try {
      const config = await getMetadataJSONWithUrlWithCache(
        process.env.REACT_APP_PRELOAD_PATH as string,
        PRELOAD_DATA_LOCAL_STORAGE_KEY
      )
      setContactList(config.help_desks.map((url: string, i: number) => ({ id: i, url })))
    } catch (err) {
      setContactList([])
    }
    setContactOpen(true)
  }, [onAction])

  return (
    <>
      {isOpen && (
        <MaintenancePageWrapper>
          <MaintenancePageModal>
            <PageContent>
              <PageTitle>温馨提示</PageTitle>
              <PageContentLineWrapper>
                <PageContentLine>加载时间较长时，可尝试切换</PageContentLine>
                <PageContentLine>其他线路更快进入平台❤️</PageContentLine>
              </PageContentLineWrapper>
            </PageContent>
            <FullWidthPrimaryButton onClick={handleSwitchLine}>切换线路</FullWidthPrimaryButton>
            <SecondButton onClick={handleContact}>联系客服</SecondButton>
          </MaintenancePageModal>
        </MaintenancePageWrapper>
      )}
      <PlaceboChooserModal
        isOpen={placeboChooserOpen}
        onClose={() => setPlaceboChooserOpen(false)}
        onClickOption={handleRetry}
      />
      <CustomerServiceModal
        isOpen={contactOpen}
        list={contactList}
        onClose={() => setContactOpen(false)}
        onClick={(item) => {
          const url = new URL(item.url)
          url.searchParams.set('id', getVisitorId())
          window.open(url.toString(), '_blank')
        }}
        overlayStyle={{
          zIndex: 'calc(var(--layer-fullpage-modal) + 3)',
        }}
      />
    </>
  )
}
